export function initShopifyBuyButton() {
    /*<![CDATA[*/
    (function () {
        var scriptURL =
            'https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js';

        if (window?.ShopifyBuy) {
            if (window.ShopifyBuy.UI) {
                ShopifyBuyInit();
            } else {
                loadScript();
            }
        } else {
            loadScript();
        }
        function loadScript() {
            var script = document.createElement('script');
            script.async = true;
            script.src = scriptURL;
            (
                document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]
            ).appendChild(script);
            script.onload = ShopifyBuyInit;
        }
        function ShopifyBuyInit() {
            var client = window?.ShopifyBuy.buildClient({
                domain: 'route-one-apparel.myshopify.com',
                storefrontAccessToken: 'eda8b509905a702c685d89a1a889413b',
            });
            window?.ShopifyBuy.UI.onReady(client).then(function (ui) {
                ui.createComponent('collection', {
                    id: '271018393682',
                    node: document.getElementById('collection-component-1678306158670'),
                    moneyFormat: '%24%7B%7Bamount%7D%7D',
                    options: {
                        product: {
                            styles: {
                                product: {
                                    '@media (min-width: 601px)': {
                                        'max-width': 'calc(33.33333% - 30px)',
                                        'margin-left': '30px',
                                        'margin-bottom': '50px',
                                        'width': 'calc(33.33333% - 30px)',
                                    },
                                    'img': {
                                        height: 'calc(100% - 15px)',
                                        position: 'absolute',
                                        left: '0',
                                        right: '0',
                                        top: '0',
                                    },
                                    'imgWrapper': {
                                        'padding-top': 'calc(75% + 15px)',
                                        'position': 'relative',
                                        'height': '0',
                                    },
                                    'title': {
                                        'color': 'white',
                                        'font-size': '14px',
                                        'font-family': 'bw-modelica, sans-serif',
                                    },
                                    'price': {
                                        'color': 'white',
                                        'font-family': 'bw-modelica, sans-serif',
                                    },
                                },
                                button: {
                                    'font-family': 'bw-modelica, sans-serif',
                                    'font-size': '17px',
                                    'padding-top': '16.5px',
                                    'padding-bottom': '16.5px',
                                    ':hover': {
                                        'background-color': '#EE6C4D',
                                    },
                                    'background-color': '#EE6C4D',
                                    ':focus': {
                                        'background-color': '#d64537',
                                    },
                                    'border-radius': '7px',
                                    'padding-left': '67px',
                                    'padding-right': '67px',
                                },
                                quantityInput: {
                                    'font-size': '17px',
                                    'padding-top': '16.5px',
                                    'padding-bottom': '16.5px',
                                },
                            },
                            buttonDestination: 'modal',
                            contents: {
                                options: false,
                            },
                            text: {
                                button: 'View product',
                            },
                            googleFonts: ['bw-modelica, Oxygen'],
                        },
                        productSet: {
                            styles: {
                                products: {
                                    '@media (min-width: 601px)': {
                                        'margin-left': '-30px',
                                    },
                                    'title': {
                                        'font-size': '14px',
                                        'font-family': 'bw-modelica, sans-serif',
                                    },
                                    'price': {
                                        'font-family': 'bw-modelica, sans-serif',
                                    },
                                },
                            },
                        },
                        modalProduct: {
                            contents: {
                                img: false,
                                imgWithCarousel: true,
                                button: false,
                                buttonWithQuantity: true,
                            },
                            styles: {
                                product: {
                                    '@media (min-width: 601px)': {
                                        'max-width': '100%',
                                        'margin-left': '0px',
                                        'margin-bottom': '0px',
                                    },
                                    'title': {
                                        'font-size': '14px',
                                        'font-family': 'bw-modelica, sans-serif',
                                    },
                                    'price': {
                                        'font-family': 'bw-modelica, sans-serif',
                                    },
                                },
                                button: {
                                    'font-family': 'bw-modelica, sans-serif',
                                    'font-size': '17px',
                                    'padding-top': '16.5px',
                                    'padding-bottom': '16.5px',
                                    ':hover': {
                                        'background-color': '#EE6C4D',
                                    },
                                    'background-color': '#EE6C4D',
                                    ':focus': {
                                        'background-color': '#EE6C4D',
                                    },
                                    'border-radius': '7px',
                                    'padding-left': '67px',
                                    'padding-right': '67px',
                                },
                                quantityInput: {
                                    'font-size': '17px',
                                    'padding-top': '16.5px',
                                    'padding-bottom': '16.5px',
                                },
                            },
                            googleFonts: ['bw-modelica, Oxygen'],
                            text: {
                                button: 'Add to cart',
                            },
                        },
                        option: {},
                        cart: {
                            styles: {
                                button: {
                                    'font-family': 'bw-modelica, sans-serif',
                                    'font-size': '17px',
                                    'padding-top': '16.5px',
                                    'padding-bottom': '16.5px',
                                    ':hover': {
                                        'background-color': '#EE6C4D',
                                    },
                                    'background-color': '#EE6C4D',
                                    ':focus': {
                                        'background-color': '#EE6C4D',
                                    },
                                    'border-radius': '7px',
                                },
                            },
                            text: {
                                total: 'Subtotal',
                                button: 'Checkout',
                            },
                            contents: {
                                note: true,
                            },
                            googleFonts: ['bw-modelica, Oxygen'],
                        },
                        toggle: {
                            styles: {
                                toggle: {
                                    'font-family': 'bw-modelica, sans-serif',
                                    'background-color': '#EE6C4D',
                                    ':hover': {
                                        'background-color': '#EE6C4D',
                                    },
                                    ':focus': {
                                        'background-color': '#EE6C4D',
                                    },
                                },
                                count: {
                                    'font-size': '17px',
                                },
                            },
                            googleFonts: ['bw-modelica, Oxygen'],
                        },
                    },
                });
            });
        }
    })();
    /*]]>*/
}
